module.exports = __webpack_public_path__ + "static/media/PeachFalcRed.10388397.png";